import { css } from '@emotion/react'
import { Theme } from '@mui/material/styles'

export const ShowOnMobile = () => css`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 24px 0;

  @media (min-width: 860px) {
    display: none;
  }
`

export const content = css`
  a {
    text-decoration: none;
  }
`
export const RexContainerLeftInnerContainer = () => css`
  @media (max-width: 860px) {
    width: 80vw;
  }
`

export const MobileHeaderText = ({ theme }: { theme: Theme }) => css`
  color: ${theme.palette.white.main};
  margin: 8px 0;
  font-weight: 700;
`

export const MobileBodyText = ({ theme }: { theme: Theme }) => css`
  color: ${theme.palette.white.main};
  margin: 8px 0;
`

export const mainText = ({ theme }: { theme: Theme }) => css`
  color: ${theme.palette.uintel.main};
  font-weight: 700;
  font-size: 1.8rem;
  line-height: 130%;
  max-width: 650px;
  margin-bottom: 20px;

  @media (max-width: 1410px) {
    font-size: 2rem;
    line-height: 3rem;
  }

  @media (max-width: 460px) {
    font-size: 1.4rem;
    line-height: 2rem;
  }
`
export const descriptionText = ({ theme }: { theme: Theme }) => css`
  color: ${theme.palette.uintel.main};
  font-weight: 400;
  font-size: 20px;
  font-style: normal;
  line-height: 160%;
  max-width: 650px;
  margin-bottom: 20px;

  @media (max-width: 1410px) {
    font-size: 2rem;
    line-height: 3rem;
  }

  @media (max-width: 460px) {
    font-size: 1.4rem;
    line-height: 2rem;
  }
`

export const marketingButton = ({ theme }: { theme: Theme }) => css`
  margin-top: ${theme.spacing(6)};
  margin-bottom: ${theme.spacing(6)};
  color: ${theme.palette.white.main};
  border-color: ${theme.palette.white.main};

  @media (max-width: 1410px) {
    font-size: 1rem;
  }
`
export const propertyLogoStyle = css`
  width: 200px;
  margin-bottom: 10px;
`
